export const SSG_VERSION = process.env.SSG_VERSION || '1.0.2';

export const SSG_BUILD = process.env.SSG_BUILD || 'nogit';

export const SSG_VERSION_FULL = `${SSG_VERSION}+${SSG_BUILD}`;
